import { axiosInstance } from '../../utils';

interface Payload {
  videoName: string;
  avatarId: string;
  audioId: string;
  text: string;
  creationId: string;
}

export const saveDraftContent = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.post('/api/videos/save-draft-content', payload);
  return res.data;
};
